import { Grid } from '@material-ui/core'
import { useFormikContext } from 'formik'
import { useMemo } from 'react'

import { PureAsyncSearchInput } from 'src/components/Formik/Forms/PureAsyncSearchInput'

import { formatLabelEndereco } from 'src/modules/pessoas/utils/labelFormatEndereco'
import { formatLabelPerson } from 'src/modules/pessoas/utils'

import { LotesFormData } from '../../types'

interface Props {
  isRestrictedEdit: boolean
}

export const LocalEntregaFields = ({ isRestrictedEdit }: Props) => {
  const { values } = useFormikContext<LotesFormData>()

  const enderecoLocalEntregaFilters = useMemo(
    () => ({
      pessoaId: values.localEntrega?.value
    }),
    [values.localEntrega?.value]
  )

  return (
    <>
      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="localEntrega"
          label="Local de Entrega (opcional)"
          url="/pessoas"
          filters={{ ativo: true }}
          labelFormat={formatLabelPerson}
          paramSearch="nomeDocumento"
          disabled={isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>

      <Grid item xs={12} sm={3}>
        <PureAsyncSearchInput
          name="enderecoLocalEntrega"
          label="Endereço Local de Entrega (opcional)"
          url="/enderecos"
          filters={enderecoLocalEntregaFilters}
          labelFormat={formatLabelEndereco}
          paramSearch="logradouro"
          disabled={!values.localEntrega?.value || isRestrictedEdit}
          allowSearchWhenDisabled
        />
      </Grid>
    </>
  )
}
